import CryptoJS from 'crypto-js'

// Função para criptografar com AES strings ss
export function encryptWithAES() {
  try {
    const text = ''

    const secretKey =
      'xB2DG199mRDicVdBDPuyphTG2TczToQ98lRR8rm48lcvYM2i2Z70QUiJ1bdBEIZt'

    const ciphertext = CryptoJS.AES.encrypt(text, secretKey).toString()

    return ciphertext
  } catch (error) {
    console.error('Erro ao criptografar:', error)
    return null
  }
}

// Função para descriptografar com AES
export function decryptWithAES(ciphertext) {
  try {
    const secretKey =
      'xB2DG199mRDicVdBDPuyphTG2TczToQ98lRR8rm48lcvYM2i2Z70QUiJ1bdBEIZt'

    const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey)

    const originalText = bytes.toString(CryptoJS.enc.Utf8)

    if (!originalText) {
      throw new Error('Descriptografado como texto inválido')
    }

    return originalText
  } catch (error) {
    console.error('Erro ao descriptografar:', error)
    return null
  }
}
